'use client';

import { cn } from '@/lib/utils';

export function CarouselArrow({
  direction,
  onClick,
  className,
}: {
  direction: 'prev' | 'next';
  onClick: () => void;
  className?: string;
}) {
  return (
    <button
      type="button"
      aria-label={direction === 'prev' ? 'Previous' : 'Next'}
      onClick={onClick}
      className={cn(
        'riz-arrow flex justify-center items-center shrink-0 rounded-[1rem] w-[5rem] h-[5rem]',
        className,
      )}
    >
      <svg
        viewBox="0 0 20 20"
        fill="none"
        aria-hidden
        className={cn('w-[2.5rem] h-[2.5rem]', direction === 'prev' && 'rotate-180')}
      >
        <path
          d="M13.75 10L7.50002 16.25L6.62502 15.375L12 10L6.62502 4.625L7.50002 3.75L13.75 10Z"
          fill="currentColor"
        />
      </svg>
      <style jsx>{`
        .riz-arrow {
          transition:
            transform 0.5s cubic-bezier(0.16, 1, 0.3, 1),
            filter 0.3s ease;
        }
        .riz-arrow:hover {
          transform: translateY(-2px);
          filter: brightness(1.08);
        }
        .riz-arrow:active {
          transform: translateY(0) scale(0.99);
        }
        .riz-arrow:focus-visible {
          outline: 2px solid #9fe0b0;
          outline-offset: 2px;
        }
        @media (prefers-reduced-motion: reduce) {
          .riz-arrow,
          .riz-arrow:hover,
          .riz-arrow:active {
            transition: none;
            transform: none;
          }
        }
      `}</style>
    </button>
  );
}
